module.exports = __webpack_public_path__ + "img/articleNotStarted.0c2c2230.svg";